/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type FormSubmitEmbedEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const formSubmitEmbedEntrypoint: EntryPoint<FormSubmitEmbedEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<FormSubmitEmbedEntrypointComponent>(
			/* webpackChunkName: "async-software-form-submit-embed-entrypoint" */ './index.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
